import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Button,
  Icon,
  Input,
  Label,
  Checkbox
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardDrugOrderWorkingUX = (props: any) => {
    return(
      <div>
        <div
          id="CardDrugOrderWorkingUX-div-195"
          style={{  position: "relative" }}>

          <div
            id="CardDrugOrderWorkingUX-div-194"
            style={{"width":"100%","height":"100%","display":"grid","gridTemplateRows":"repeat(1, 1fr)","gridTemplateColumns":"repeat(60, 1fr)"}}>
            <div
              className="ui form small"
              id="CardDrugOrderWorkingUX-div-327"
              style={{"gridRow":`1/1`,"gridColumn":"2/60"}}>

              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-432"
                style={{marginTop: "1rem", alignItems: "center"}}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-433">
                  <div
                    id="CardDrugOrderWorkingUX-div-436"
                    style={{fontSize: "1.2rem", fontWeight: "bold"}}>
                    {props.nameTypeOrder}
                  </div>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-434"
                  style={{flex:1}}>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-435"
                  inline={true}
                  style={{display: "flex", alignItems: "center"}}>
                  <div
                    id="CardDrugOrderWorkingUX-div-437"
                    style={{display:  props.showTelepharType?"flex":"none", justifyContent: "flex-end"}}>

                    <Checkbox
                      checked={props.telepharType === "DELIVERY"}
                      className="blue"
                      id="CardDrugOrderWorkingUX-Checkbox-440"
                      label={props.languageUX === "en" ? "Home delivery" : "บริการส่งถึงบ้าน"}
                      style={{fontWeight: "normal", textAlign: "left", maxWidth: "max-content", width: "calc(100% - 13rem)"}}>
                    </Checkbox>
                    <Checkbox
                      checked={props.telepharType === "INTRA"}
                      className="blue"
                      id="CardDrugOrderWorkingUX-Checkbox-441"
                      label={props.languageUX === "en" ? "Intrahospital Telepharmacy" : "เภสัชกรรมทางไกลภายในโรงพยาบาล"}
                      style={{fontWeight: "normal", margin: "0 0rem 0 1rem", textAlign: "left", maxWidth: "max-content", width: "calc(100% - 9rem)"}}>
                    </Checkbox>
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-457">
                    {props.subAdrPopup}
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-438">
                    {props.orderStatus}
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-439">
                    {props.orderPaymentStatus}
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-465"
                inline={true}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-466"
                  width={8}>
                  <div
                    id="CardDrugOrderWorkingUX-div-467"
                    style={{ width: "100%" }}>
                    {props.msgVerbal}
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-368"
                inline={true}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-370">
                  <label
                    id="CardDrugOrderWorkingUX-label-374"
                    style={{minWidth: "110px", maxWidth: "110px"}}>
                    {props.languageUX === "en" ? "Diagnosis" : "การวินิจฉัย"}
                  </label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-371"
                  inline={true}
                  width={16}>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-377"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.diagnosis || "\u00a0"}
                  </Label>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-369"
                inline={true}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-372">
                  <label
                    id="CardDrugOrderWorkingUX-label-375"
                    style={{minWidth: "110px", maxWidth: "110px"}}>
                    {props.languageUX === "en" ? "Doctor Note" : "หมายเหตุของแพทย์"}
                  </label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-373"
                  inline={true}
                  width={10}>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-376"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.doctor_note || "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-459"
                  width="6">
                  <label
                    id="CardDrugOrderWorkingUX-label-460">
                    Prescription date :
                  </label>
                  <label
                    id="CardDrugOrderWorkingUX-label-461">
                    {props.drugOrder?.order_for_date || ""}
                  </label>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-382"
                inline={true}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-383"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-386"
                    style={{minWidth: "110px", maxWidth: "110px", marginRight: "12px", display: props.drugOrder?.order_receive_fullname ? "" : "none" }}>
                    {props.languageUX === "en" ? "The commander" : "ผู้สั่ง"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-389"
                    style={{padding: "0.78rem", width: "100%", display: props.drugOrder?.order_receive_fullname ? "" : "none"}}>
                    {props.drugOrder?.order_receive_fullname}
                  </Label>
                  <label
                    id="CardDrugOrderWorkingUX-label-463"
                    style={{minWidth: "110px", maxWidth: "110px", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "Prescribing physician" : "แพทย์ผู้สั่ง"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-464"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.requested?.name || props.drugOrder?.doctorOrderName || "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-384"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-387"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "Time" : "เวลา"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-390"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.requestTime|| "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-385"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-388"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "Department" : "แผนก"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-391"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.requested?.division || "\u00a0"}
                  </Label>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-392"
                inline={true}
                style={{display : props.drugOrder?.printed ? "": "none"}}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-393"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-396"
                    style={{minWidth: "110px", maxWidth: "110px", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "Verifyer" : "ผู้ Verify"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-399"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.printed?.name || "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-394"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-397"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "time" : "เวลา"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-400"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.printedTime|| "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-395"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-398"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "department" : "แผนก"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-401"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.printed?.division || "\u00a0"}
                  </Label>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-402"
                inline={true}
                style={{display: props.drugOrder?.checked ? "": "none"}}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-405"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-408"
                    style={{minWidth: "110px", maxWidth: "110px", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "Checker" : "ผู้ Check"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-411"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.checked?.name || "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-414"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-422"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "time" : "เวลา"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-431"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.checkedTime|| "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-415"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-423"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "department" : "แผนก"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-430"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.checked?.division || "\u00a0"}
                  </Label>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-403"
                inline={true}
                style={{display : props.drugOrder?.delivered ? "": "none" }}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-406"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-409"
                    style={{minWidth: "110px", maxWidth: "110px", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "Payer" : "ผู้จ่าย"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-412"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.delivered?.name || "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-416"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-420"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "time" : "เวลา"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-429"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.deliveredTime|| "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-417"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-421"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "department" : "แผนก"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-428"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.delivered?.division || "\u00a0"}
                  </Label>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-404"
                inline={true}
                style={{display : props.drugOrder?.transported ? "": "none"}}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-407"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-410"
                    style={{minWidth: "110px", maxWidth: "110px", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "Carrier" : "ผู้ขนส่ง"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-413"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.transported?.name || "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-418"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-424"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "time" : "เวลา"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-427"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.transportedTime|| "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-419"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-425"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "department" : "แผนก"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-426"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.transported?.division || "\u00a0"}
                  </Label>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-445"
                inline={true}
                style={{display : props.drugOrder?.received ? "": "none"}}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-446"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-447"
                    style={{minWidth: "110px", maxWidth: "110px", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "recipient" : "ผู้รับ"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-448"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.received?.name || "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-449"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-450"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "time" : "เวลา"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-451"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.receivedTime|| "\u00a0"}
                  </Label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-452"
                  inline={true}
                  width={6}>
                  <label
                    id="CardDrugOrderWorkingUX-label-453"
                    style={{minWidth: "50px", flexShrink: 0, whiteSpace: "nowrap", textAlign: "right", marginRight: "12px"}}>
                    {props.languageUX === "en" ? "department" : "แผนก"}
                  </label>
                  <Label
                    id="CardDrugOrderWorkingUX-Label-454"
                    style={{padding: "0.78rem", width: "100%"}}>
                    {props.drugOrder?.received?.division || "\u00a0"}
                  </Label>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-378">
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-379"
                  style={{display: props.showToolBox ? "flex" : ""}}
                  width={16}>
                  <Table
                    className="--rt-tbody-overflow-y-hidden"
                    data={props.drugOrderItems}
                    getTrProps={props.rowProps}
                    headers={props.showPrintLabel? ",ชื่อยา,Dose,Unit,Route,Site,Frequency,PRN,Qty,Onhand Stock,Unit,Price/Unit,Total Price, Label": ",ชื่อยา,Dose,Unit,Route,Site,Frequency,PRN,Qty,Onhand Stock,Unit,Price/Unit,Total Price"}
                    id="tb-medOrderReqList"
                    keys={props.showPrintLabel? "check, name_status, dose, code_unit, code_route,code_site, code_frequency, prn, quantity, onhand, code_stock, price_unit, price_total,print_label":"check, name_status, dose, code_unit, code_route,code_site, code_frequency, prn, quantity, onhand, code_stock, price_unit, price_total"}
                    minRows="4"
                    showPagination={false}
                    style={{height: "255px", width: props.showToolBox ? "77%" : "100%", display: "none" }}
                    widths={props.showPrintLabel? "30,^150,^60,^60,^100,^100,^125,^80,^70,^60,^80,^80,^70,^55":"30,^150,^60,^60,^100,^100,^125,^80,^50,^70,^80,^70,^60"}>
                  </Table>
                  <div
                    id="CardDrugOrderWorkingUX-div-462"
                    style={{ width: props.showToolBox ? "77%" : "100%"}}>
                    {props.tableElement}
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-381"
                    style={{width: "23%"}}>
                    {props.SubDrugOrderToolbox}
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-347"
                inline={true}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-348">
                  <label
                    id="CardDrugOrderWorkingUX-label-358"
                    style={{fontWeight: "normal", minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Ordering department" : "แผนกที่สั่ง"}
                  </label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-349"
                  inline={true}
                  width={4}>
                  <Input
                    fluid={true}
                    id="CardDrugOrderWorkingUX-Input-367"
                    readOnly={true}
                    value={props.drugOrder?.order_div || ""}>
                  </Input>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-350">
                  <label
                    id="CardDrugOrderWorkingUX-label-359"
                    style={{fontWeight: "normal", minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Pharmacy" : "ห้องยา"}
                  </label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-351"
                  inline={true}
                  width={4}>
                  <Input
                    fluid={true}
                    id="CardDrugOrderWorkingUX-Input-366"
                    readOnly={true}
                    value={props.drugOrder?.order_perform_div || ""}>
                  </Input>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-352">
                  <label
                    id="CardDrugOrderWorkingUX-label-360"
                    style={{fontWeight: "normal", minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Total price" : "ราคารวม"}
                  </label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-353"
                  inline={true}
                  width={3}>
                  <Input
                    fluid={true}
                    id="CardDrugOrderWorkingUX-Input-365"
                    readOnly={true}
                    value={Number(props.sumPriceTotal||"0").toLocaleString("en-US", {minimumFractionDigits: 2,maximumFractionDigits: 2,})}>
                  </Input>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-354">
                  <label
                    id="CardDrugOrderWorkingUX-label-361"
                    style={{fontWeight: "normal", minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Reimbursable" : "เบิกได้"}
                  </label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-355"
                  inline={true}
                  width={3}>
                  <Input
                    fluid={true}
                    id="CardDrugOrderWorkingUX-Input-364"
                    readOnly={true}
                    value={ Number(props.sumPriceClaimable||"0").toLocaleString("en-US", {minimumFractionDigits: 2,maximumFractionDigits: 2,})}>
                  </Input>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-356">
                  <label
                    id="CardDrugOrderWorkingUX-label-362"
                    style={{fontWeight: "normal", minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Non-reimbursable" : "เบิกไม่ได้"}
                  </label>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-357"
                  inline={true}
                  width={3}>
                  <Input
                    fluid={true}
                    id="CardDrugOrderWorkingUX-Input-363"
                    readOnly={true}
                    value={Number(props.sumPriceNonClaimable||"0").toLocaleString("en-US", {minimumFractionDigits: 2,maximumFractionDigits: 2,})}>
                  </Input>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-328"
                inline={true}
                style={{minWidth: "max-content"}}>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-329"
                  inline={true}>
                  <Button
                    id="CardDrugOrderWorkingUX-Button-330"
                    onClick={props.handleOnLog}
                    size="small"
                    style={{marginRight: "0.5rem"}}>
                    {props.languageUX === "en" ? "LOG" : "ดูบันทึก"}
                  </Button>
                  <Button
                    id="CardDrugOrderWorkingUX-Button-331"
                    loading={props.loadingNarcotic}
                    onClick={props.narcoticPrint}
                    size="small"
                    style={{display: props.buttonActions?.narcotic?.show ? "":"none",marginRight: "0.5rem"}}>
                    {props.languageUX === "en" ? "Form Y.S. 5" : "แบบ ย.ส. 5"}
                  </Button>
                  <Button
                    id="CardDrugOrderWorkingUX-Button-468"
                    loading={props.loadingStatus?.PRINT_PSYCHOTROPIC_FORM}
                    onClick={props.onPrintPsychotropic}
                    size="small"
                    style={{display: props.buttonActions?.psychotropic?.show ? "":"none",marginRight: "0.5rem"}}>
                    {props.languageUX === "en" ? "Prescription for psychotropic substances" : "ใบสั่งจ่ายวัตถุออกฤทธิ์"}
                  </Button>
                  <Button
                    id="CardDrugOrderWorkingUX-Button-332"
                    onClick={props?.OnReprint}
                    size="small"
                    style={{display: props.buttonActions?.reprint?.show ? "" : "none",marginRight: "0.5rem"}}>
                    {props.languageUX === "en" ? "Reprint" : "พิมพ์ซ้ำ"}
                  </Button>
                  <Button
                    id="CardDrugOrderWorkingUX-Button-455"
                    onClick={props.onClickDiscount}
                    size="small"
                    style={{display: props.buttonActions?.discount?.show ? "" : "none",marginRight: "0.5rem"}}>
                    {props.languageUX === "en" ? "Discount" : "การลดราคา"}
                  </Button>
                  <Button
                    disabled={props.disabledPrintDrugAdviceBtn}
                    icon={true}
                    id="CardDrugOrderWorkingUX-Button-333"
                    labelPosition="left"
                    onClick={props.printDrugAdvice}
                    size="small"
                    style={{...(props.buttonActions?.drugRecommendation?.show ? {}: {display: "none"})}}>
                    {props.languageUX === "en" ? "Drug use instructions" : "คำแนะนำการใช้ยา"}
                    <Icon
                      id="CardDrugOrderWorkingUX-Icon-334"
                      name="print">
                    </Icon>
                  </Button>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-335"
                  style={{flex:1, padding:0}}>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-340"
                  style={{display:props.buttonActions?.additional?.show?"":"none"}}>
                  <div
                    id="CardDrugOrderWorkingUX-div-341">
                    {props.additionalProps}
                  </div>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-336"
                  inline={true}
                  style={{display: "flex"}}>
                  <div
                    id="CardDrugOrderWorkingUX-div-458">
                    {props.passwordInput}
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-456"
                    style={{marginRight: "0.5rem",display:props.buttonActions?.language?.show ? "" : "none"}}>
                    {props.buttonLanguage}
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-337"
                    style={{marginRight: "0.5rem",display:props.buttonActions?.refill?.show ? "" : "none",}}>
                    {props.buttonRefill}
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-444"
                    style={{marginRight: "0.5rem",display:props.buttonActions?.telephar?.show ? "" : "none"}}>
                    {props.buttonTelePharmacy}
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-342"
                    style={{marginRight: "0.5rem",display: props.buttonActions?.return?.show ?"":"none"}}>
                    {props.buttonReturn}
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-338"
                    style={{marginRight: "0.5rem",display:props.buttonActions?.forward?.show? "" : "none"}}>
                    {props.buttonForward}
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-339"
                    style={{marginRight: "0.5rem",display:props.buttonActions?.backward?.show ? "" : "none"}}>
                    {props.buttonBackward}
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-442"
                    style={{marginRight: "0.5rem",display:props.buttonActions?.endConsult?.show ? "" : "none"}}>
                    {props.buttonEndConsult}
                  </div>
                  <div
                    id="CardDrugOrderWorkingUX-div-443"
                    style={{display:props.buttonActions?.callAgain?.show ? "" : "none"}}>
                    {props.buttonVideoCallAgain}
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardDrugOrderWorkingUX-FormGroup-343">
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-344"
                  style={{flex:1}}>
                </FormField>
                <FormField
                  id="CardDrugOrderWorkingUX-FormField-345"
                  style={{marginRight: "20%"}}>
                  <div
                    id="CardDrugOrderWorkingUX-div-346">
                    {props?.drugDelivery}
                  </div>
                </FormField>
              </FormGroup>
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardDrugOrderWorkingUX

export const screenPropsDefault = {"backwardActionButton":"REJECT","forwardActionButton":"VERIFY AND PRINT","language":"TH"}

/* Date Time : Wed Sep 30 2026 16:58:28 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 194,
      "label": "divgrid",
      "name": "div",
      "parent": 195,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-194"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"gridTemplateRows\":\"repeat(1, 1fr)\",\"gridTemplateColumns\":\"repeat(60, 1fr)\"}"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": null,
      "id": 195,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-195"
        },
        "style": {
          "type": "code",
          "value": "{  position: \"relative\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 327,
      "name": "div",
      "parent": 194,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form small"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-327"
        },
        "style": {
          "type": "code",
          "value": "{\"gridRow\":`1/1`,\"gridColumn\":\"2/60\"}"
        }
      },
      "seq": 327,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 328,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-328"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 445,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 329,
      "name": "FormField",
      "parent": 328,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-329"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 329,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 330,
      "name": "Button",
      "parent": 329,
      "props": {
        "children": {
          "type": "value",
          "value": "ดูบันทึก",
          "valueEN": "LOG"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Button-330"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleOnLog"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 330,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 331,
      "name": "Button",
      "parent": 329,
      "props": {
        "children": {
          "type": "value",
          "value": "แบบ ย.ส. 5",
          "valueEN": "Form Y.S. 5"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Button-331"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingNarcotic"
        },
        "onClick": {
          "type": "code",
          "value": "props.narcoticPrint"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.buttonActions?.narcotic?.show ? \"\":\"none\",marginRight: \"0.5rem\"}"
        }
      },
      "seq": 331,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 332,
      "name": "Button",
      "parent": 329,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ซ้ำ",
          "valueEN": "Reprint"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Button-332"
        },
        "onClick": {
          "type": "code",
          "value": "props?.OnReprint"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.buttonActions?.reprint?.show ? \"\" : \"none\",marginRight: \"0.5rem\"}"
        }
      },
      "seq": 333,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 333,
      "name": "Button",
      "parent": 329,
      "props": {
        "children": {
          "type": "value",
          "value": "คำแนะนำการใช้ยา",
          "valueEN": "Drug use instructions"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledPrintDrugAdviceBtn"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Button-333"
        },
        "labelPosition": {
          "type": "value",
          "value": "left"
        },
        "onClick": {
          "type": "code",
          "value": "props.printDrugAdvice"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{...(props.buttonActions?.drugRecommendation?.show ? {}: {display: \"none\"})}"
        }
      },
      "seq": 468,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 334,
      "name": "Icon",
      "parent": 333,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Icon-334"
        },
        "name": {
          "type": "value",
          "value": "print"
        }
      },
      "seq": 334,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 335,
      "name": "FormField",
      "parent": 328,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-335"
        },
        "style": {
          "type": "code",
          "value": "{flex:1, padding:0}"
        }
      },
      "seq": 335,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 336,
      "name": "FormField",
      "parent": 328,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-336"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 340,
      "void": false
    },
    {
      "from": null,
      "id": 337,
      "name": "div",
      "parent": 336,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonRefill"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-337"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\",display:props.buttonActions?.refill?.show ? \"\" : \"none\",}"
        }
      },
      "seq": 339,
      "void": false
    },
    {
      "from": null,
      "id": 338,
      "name": "div",
      "parent": 336,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonForward"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-338"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\",display:props.buttonActions?.forward?.show? \"\" : \"none\"}"
        }
      },
      "seq": 443,
      "void": false
    },
    {
      "from": null,
      "id": 339,
      "name": "div",
      "parent": 336,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonBackward"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-339"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\",display:props.buttonActions?.backward?.show ? \"\" : \"none\"}"
        }
      },
      "seq": 444,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 340,
      "name": "FormField",
      "parent": 328,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-340"
        },
        "style": {
          "type": "code",
          "value": "{display:props.buttonActions?.additional?.show?\"\":\"none\"}"
        }
      },
      "seq": 336,
      "void": false
    },
    {
      "from": null,
      "id": 341,
      "name": "div",
      "parent": 340,
      "props": {
        "children": {
          "type": "code",
          "value": "props.additionalProps"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-341"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 341,
      "void": false
    },
    {
      "from": null,
      "id": 342,
      "name": "div",
      "parent": 336,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonReturn"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-342"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\",display: props.buttonActions?.return?.show ?\"\":\"none\"}"
        }
      },
      "seq": 442,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 343,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-343"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 465,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 344,
      "name": "FormField",
      "parent": 343,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-344"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 344,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 345,
      "name": "FormField",
      "parent": 343,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-345"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"20%\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 345,
      "void": false
    },
    {
      "from": null,
      "id": 346,
      "name": "div",
      "parent": 345,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.drugDelivery"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-346"
        }
      },
      "seq": 346,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 347,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-347"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 432,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 348,
      "name": "FormField",
      "parent": 347,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-348"
        }
      },
      "seq": 348,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 349,
      "name": "FormField",
      "parent": 347,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-349"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 349,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 350,
      "name": "FormField",
      "parent": 347,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-350"
        }
      },
      "seq": 350,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 351,
      "name": "FormField",
      "parent": 347,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-351"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 351,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 352,
      "name": "FormField",
      "parent": 347,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-352"
        }
      },
      "seq": 352,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 353,
      "name": "FormField",
      "parent": 347,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-353"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 353,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 354,
      "name": "FormField",
      "parent": 347,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-354"
        }
      },
      "seq": 354,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 355,
      "name": "FormField",
      "parent": 347,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-355"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 355,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 356,
      "name": "FormField",
      "parent": 347,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-356"
        }
      },
      "seq": 356,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 357,
      "name": "FormField",
      "parent": 347,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-357"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 357,
      "void": false
    },
    {
      "from": null,
      "id": 358,
      "name": "label",
      "parent": 348,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนกที่สั่ง",
          "valueEN": "Ordering department"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-358"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 358,
      "void": false
    },
    {
      "from": null,
      "id": 359,
      "name": "label",
      "parent": 350,
      "props": {
        "children": {
          "type": "value",
          "value": "ห้องยา",
          "valueEN": "Pharmacy"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-359"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 359,
      "void": false
    },
    {
      "from": null,
      "id": 360,
      "name": "label",
      "parent": 352,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคารวม",
          "valueEN": "Total price"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-360"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 360,
      "void": false
    },
    {
      "from": null,
      "id": 361,
      "name": "label",
      "parent": 354,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกได้",
          "valueEN": "Reimbursable"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-361"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 361,
      "void": false
    },
    {
      "from": null,
      "id": 362,
      "name": "label",
      "parent": 356,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกไม่ได้",
          "valueEN": "Non-reimbursable"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-362"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 362,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 363,
      "name": "Input",
      "parent": 357,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Input-363"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "Number(props.sumPriceNonClaimable||\"0\").toLocaleString(\"en-US\", {minimumFractionDigits: 2,maximumFractionDigits: 2,})"
        }
      },
      "seq": 363,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 364,
      "name": "Input",
      "parent": 355,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Input-364"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": " Number(props.sumPriceClaimable||\"0\").toLocaleString(\"en-US\", {minimumFractionDigits: 2,maximumFractionDigits: 2,})"
        }
      },
      "seq": 364,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 365,
      "name": "Input",
      "parent": 353,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Input-365"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "Number(props.sumPriceTotal||\"0\").toLocaleString(\"en-US\", {minimumFractionDigits: 2,maximumFractionDigits: 2,})"
        }
      },
      "seq": 365,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 366,
      "name": "Input",
      "parent": 351,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Input-366"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.drugOrder?.order_perform_div || \"\""
        }
      },
      "seq": 366,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 367,
      "name": "Input",
      "parent": 349,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Input-367"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.drugOrder?.order_div || \"\""
        }
      },
      "seq": 367,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 368,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-368"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 347,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 369,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-369"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 368,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 370,
      "name": "FormField",
      "parent": 368,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-370"
        }
      },
      "seq": 370,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 371,
      "name": "FormField",
      "parent": 368,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-371"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 371,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 372,
      "name": "FormField",
      "parent": 369,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-372"
        }
      },
      "seq": 372,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 373,
      "name": "FormField",
      "parent": 369,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-373"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 373,
      "void": false
    },
    {
      "from": null,
      "id": 374,
      "name": "label",
      "parent": 370,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัย",
          "valueEN": "Diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-374"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"110px\", maxWidth: \"110px\"}"
        }
      },
      "seq": 374,
      "void": false
    },
    {
      "from": null,
      "id": 375,
      "name": "label",
      "parent": 372,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุของแพทย์",
          "valueEN": "Doctor Note"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-375"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"110px\", maxWidth: \"110px\"}"
        }
      },
      "seq": 375,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 376,
      "name": "Label",
      "parent": 373,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.doctor_note || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-376"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 376,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 377,
      "name": "Label",
      "parent": 371,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.diagnosis || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-377"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 377,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 378,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-378"
        }
      },
      "seq": 404,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 379,
      "name": "FormField",
      "parent": 378,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-379"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showToolBox ? \"flex\" : \"\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 379,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 380,
      "name": "Table",
      "parent": 379,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.drugOrderItems"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.rowProps"
        },
        "headers": {
          "type": "code",
          "value": "props.showPrintLabel? \",ชื่อยา,Dose,Unit,Route,Site,Frequency,PRN,Qty,Onhand Stock,Unit,Price/Unit,Total Price, Label\": \",ชื่อยา,Dose,Unit,Route,Site,Frequency,PRN,Qty,Onhand Stock,Unit,Price/Unit,Total Price\""
        },
        "id": {
          "type": "value",
          "value": "tb-medOrderReqList"
        },
        "keys": {
          "type": "code",
          "value": "props.showPrintLabel? \"check, name_status, dose, code_unit, code_route,code_site, code_frequency, prn, quantity, onhand, code_stock, price_unit, price_total,print_label\":\"check, name_status, dose, code_unit, code_route,code_site, code_frequency, prn, quantity, onhand, code_stock, price_unit, price_total\""
        },
        "minRows": {
          "type": "value",
          "value": "4"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"255px\", width: props.showToolBox ? \"77%\" : \"100%\", display: \"none\" }"
        },
        "widths": {
          "type": "code",
          "value": "props.showPrintLabel? \"30,^150,^60,^60,^100,^100,^125,^80,^70,^60,^80,^80,^70,^55\":\"30,^150,^60,^60,^100,^100,^125,^80,^50,^70,^80,^70,^60\""
        }
      },
      "seq": 380,
      "void": false
    },
    {
      "from": null,
      "id": 381,
      "name": "div",
      "parent": 379,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SubDrugOrderToolbox"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-381"
        },
        "style": {
          "type": "code",
          "value": "{width: \"23%\"}"
        }
      },
      "seq": 462,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 382,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-382"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 369,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 383,
      "name": "FormField",
      "parent": 382,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-383"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 383,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 384,
      "name": "FormField",
      "parent": 382,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-384"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 384,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 385,
      "name": "FormField",
      "parent": 382,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-385"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 385,
      "void": false
    },
    {
      "from": null,
      "id": 386,
      "name": "label",
      "parent": 383,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้สั่ง",
          "valueEN": "The commander"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-386"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"110px\", maxWidth: \"110px\", marginRight: \"12px\", display: props.drugOrder?.order_receive_fullname ? \"\" : \"none\" }"
        }
      },
      "seq": 386,
      "void": false
    },
    {
      "from": null,
      "id": 387,
      "name": "label",
      "parent": 384,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "Time"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-387"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 387,
      "void": false
    },
    {
      "from": null,
      "id": 388,
      "name": "label",
      "parent": 385,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "Department"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-388"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 388,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 389,
      "name": "Label",
      "parent": 383,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.order_receive_fullname"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-389"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\", display: props.drugOrder?.order_receive_fullname ? \"\" : \"none\"}"
        }
      },
      "seq": 389,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 390,
      "name": "Label",
      "parent": 384,
      "props": {
        "children": {
          "type": "code",
          "value": "props.requestTime|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-390"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 390,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 391,
      "name": "Label",
      "parent": 385,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.requested?.division || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-391"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 391,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 392,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-392"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display : props.drugOrder?.printed ? \"\": \"none\"}"
        }
      },
      "seq": 378,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 393,
      "name": "FormField",
      "parent": 392,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-393"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 393,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 394,
      "name": "FormField",
      "parent": 392,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-394"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 394,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 395,
      "name": "FormField",
      "parent": 392,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-395"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 395,
      "void": false
    },
    {
      "from": null,
      "id": 396,
      "name": "label",
      "parent": 393,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ Verify",
          "valueEN": "Verifyer"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-396"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"110px\", maxWidth: \"110px\", marginRight: \"12px\"}"
        }
      },
      "seq": 396,
      "void": false
    },
    {
      "from": null,
      "id": 397,
      "name": "label",
      "parent": 394,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "time"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-397"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 397,
      "void": false
    },
    {
      "from": null,
      "id": 398,
      "name": "label",
      "parent": 395,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-398"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 398,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 399,
      "name": "Label",
      "parent": 393,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.printed?.name || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-399"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 399,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 400,
      "name": "Label",
      "parent": 394,
      "props": {
        "children": {
          "type": "code",
          "value": "props.printedTime|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-400"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 400,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 401,
      "name": "Label",
      "parent": 395,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.printed?.division || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-401"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 401,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 402,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-402"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.drugOrder?.checked ? \"\": \"none\"}"
        }
      },
      "seq": 382,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 403,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-403"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display : props.drugOrder?.delivered ? \"\": \"none\" }"
        }
      },
      "seq": 392,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 404,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-404"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display : props.drugOrder?.transported ? \"\": \"none\"}"
        }
      },
      "seq": 402,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 405,
      "name": "FormField",
      "parent": 402,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-405"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 405,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 406,
      "name": "FormField",
      "parent": 403,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-406"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 406,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 407,
      "name": "FormField",
      "parent": 404,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-407"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 407,
      "void": false
    },
    {
      "from": null,
      "id": 408,
      "name": "label",
      "parent": 405,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ Check",
          "valueEN": "Checker"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-408"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"110px\", maxWidth: \"110px\", marginRight: \"12px\"}"
        }
      },
      "seq": 408,
      "void": false
    },
    {
      "from": null,
      "id": 409,
      "name": "label",
      "parent": 406,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้จ่าย",
          "valueEN": "Payer"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-409"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"110px\", maxWidth: \"110px\", marginRight: \"12px\"}"
        }
      },
      "seq": 409,
      "void": false
    },
    {
      "from": null,
      "id": 410,
      "name": "label",
      "parent": 407,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ขนส่ง",
          "valueEN": "Carrier"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-410"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"110px\", maxWidth: \"110px\", marginRight: \"12px\"}"
        }
      },
      "seq": 410,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 411,
      "name": "Label",
      "parent": 405,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.checked?.name || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-411"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 411,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 412,
      "name": "Label",
      "parent": 406,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.delivered?.name || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-412"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 412,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 413,
      "name": "Label",
      "parent": 407,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.transported?.name || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-413"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 413,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 414,
      "name": "FormField",
      "parent": 402,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-414"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 414,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 415,
      "name": "FormField",
      "parent": 402,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-415"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 415,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 416,
      "name": "FormField",
      "parent": 403,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-416"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 416,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 417,
      "name": "FormField",
      "parent": 403,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-417"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 417,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 418,
      "name": "FormField",
      "parent": 404,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-418"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 418,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 419,
      "name": "FormField",
      "parent": 404,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-419"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 419,
      "void": false
    },
    {
      "from": null,
      "id": 420,
      "name": "label",
      "parent": 416,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "time"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-420"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 420,
      "void": false
    },
    {
      "from": null,
      "id": 421,
      "name": "label",
      "parent": 417,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-421"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 421,
      "void": false
    },
    {
      "from": null,
      "id": 422,
      "name": "label",
      "parent": 414,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "time"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-422"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 422,
      "void": false
    },
    {
      "from": null,
      "id": 423,
      "name": "label",
      "parent": 415,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-423"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 423,
      "void": false
    },
    {
      "from": null,
      "id": 424,
      "name": "label",
      "parent": 418,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "time"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-424"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 424,
      "void": false
    },
    {
      "from": null,
      "id": 425,
      "name": "label",
      "parent": 419,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-425"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 425,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 426,
      "name": "Label",
      "parent": 419,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.transported?.division || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-426"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 426,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 427,
      "name": "Label",
      "parent": 418,
      "props": {
        "children": {
          "type": "code",
          "value": "props.transportedTime|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-427"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 427,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 428,
      "name": "Label",
      "parent": 417,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.delivered?.division || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-428"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 428,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 429,
      "name": "Label",
      "parent": 416,
      "props": {
        "children": {
          "type": "code",
          "value": "props.deliveredTime|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-429"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 429,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 430,
      "name": "Label",
      "parent": 415,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.checked?.division || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-430"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 430,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 431,
      "name": "Label",
      "parent": 414,
      "props": {
        "children": {
          "type": "code",
          "value": "props.checkedTime|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-431"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 431,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 432,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-432"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\", alignItems: \"center\"}"
        }
      },
      "seq": 328,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 433,
      "name": "FormField",
      "parent": 432,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-433"
        }
      },
      "seq": 433,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 434,
      "name": "FormField",
      "parent": 432,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-434"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 434,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 435,
      "name": "FormField",
      "parent": 432,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-435"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 435,
      "void": false
    },
    {
      "from": null,
      "id": 436,
      "name": "div",
      "parent": 433,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nameTypeOrder"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-436"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 436,
      "void": false
    },
    {
      "from": null,
      "id": 437,
      "name": "div",
      "parent": 435,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-437"
        },
        "style": {
          "type": "code",
          "value": "{display:  props.showTelepharType?\"flex\":\"none\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 437,
      "void": false
    },
    {
      "from": null,
      "id": 438,
      "name": "div",
      "parent": 435,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderStatus"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-438"
        }
      },
      "seq": 439,
      "void": false
    },
    {
      "from": null,
      "id": 439,
      "name": "div",
      "parent": 435,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderPaymentStatus"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-439"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 457,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 440,
      "name": "Checkbox",
      "parent": 437,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.telepharType === \"DELIVERY\""
        },
        "className": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Checkbox-440"
        },
        "label": {
          "type": "value",
          "value": "บริการส่งถึงบ้าน",
          "valueEN": "Home delivery"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", textAlign: \"left\", maxWidth: \"max-content\", width: \"calc(100% - 13rem)\"}"
        }
      },
      "seq": 440,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 441,
      "name": "Checkbox",
      "parent": 437,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.telepharType === \"INTRA\""
        },
        "className": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Checkbox-441"
        },
        "label": {
          "type": "value",
          "value": "เภสัชกรรมทางไกลภายในโรงพยาบาล",
          "valueEN": "Intrahospital Telepharmacy"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", margin: \"0 0rem 0 1rem\", textAlign: \"left\", maxWidth: \"max-content\", width: \"calc(100% - 9rem)\"}"
        }
      },
      "seq": 441,
      "void": false
    },
    {
      "from": null,
      "id": 442,
      "name": "div",
      "parent": 336,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonEndConsult"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-442"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\",display:props.buttonActions?.endConsult?.show ? \"\" : \"none\"}"
        }
      },
      "seq": 456,
      "void": false
    },
    {
      "from": null,
      "id": 443,
      "name": "div",
      "parent": 336,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonVideoCallAgain"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-443"
        },
        "style": {
          "type": "code",
          "value": "{display:props.buttonActions?.callAgain?.show ? \"\" : \"none\"}"
        }
      },
      "seq": 458,
      "void": false
    },
    {
      "from": null,
      "id": 444,
      "name": "div",
      "parent": 336,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonTelePharmacy"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-444"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\",display:props.buttonActions?.telephar?.show ? \"\" : \"none\"}"
        }
      },
      "seq": 342,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 445,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-445"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display : props.drugOrder?.received ? \"\": \"none\"}"
        }
      },
      "seq": 403,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 446,
      "name": "FormField",
      "parent": 445,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-446"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 446,
      "void": false
    },
    {
      "from": null,
      "id": 447,
      "name": "label",
      "parent": 446,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้รับ",
          "valueEN": "recipient"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-447"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"110px\", maxWidth: \"110px\", marginRight: \"12px\"}"
        }
      },
      "seq": 447,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 448,
      "name": "Label",
      "parent": 446,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.received?.name || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-448"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 448,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 449,
      "name": "FormField",
      "parent": 445,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-449"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 449,
      "void": false
    },
    {
      "from": null,
      "id": 450,
      "name": "label",
      "parent": 449,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "time"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-450"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 450,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 451,
      "name": "Label",
      "parent": 449,
      "props": {
        "children": {
          "type": "code",
          "value": "props.receivedTime|| \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-451"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 451,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 452,
      "name": "FormField",
      "parent": 445,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-452"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 452,
      "void": false
    },
    {
      "from": null,
      "id": 453,
      "name": "label",
      "parent": 452,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-453"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\", flexShrink: 0, whiteSpace: \"nowrap\", textAlign: \"right\", marginRight: \"12px\"}"
        }
      },
      "seq": 453,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 454,
      "name": "Label",
      "parent": 452,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.received?.division || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-454"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 454,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 455,
      "name": "Button",
      "parent": 329,
      "props": {
        "children": {
          "type": "value",
          "value": "การลดราคา",
          "valueEN": "Discount"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Button-455"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickDiscount"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.buttonActions?.discount?.show ? \"\" : \"none\",marginRight: \"0.5rem\"}"
        }
      },
      "seq": 455,
      "void": false
    },
    {
      "from": null,
      "id": 456,
      "name": "div",
      "parent": 336,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonLanguage"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-456"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\",display:props.buttonActions?.language?.show ? \"\" : \"none\"}"
        }
      },
      "seq": 338,
      "void": false
    },
    {
      "from": null,
      "id": 457,
      "name": "div",
      "parent": 435,
      "props": {
        "children": {
          "type": "code",
          "value": "props.subAdrPopup"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-457"
        }
      },
      "seq": 438,
      "void": false
    },
    {
      "from": null,
      "id": 458,
      "name": "div",
      "parent": 336,
      "props": {
        "children": {
          "type": "code",
          "value": "props.passwordInput"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-458"
        }
      },
      "seq": 337,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 459,
      "name": "FormField",
      "parent": 369,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-459"
        },
        "width": {
          "type": "value",
          "value": "6"
        }
      },
      "seq": 459,
      "void": false
    },
    {
      "from": null,
      "id": 460,
      "name": "label",
      "parent": 459,
      "props": {
        "children": {
          "type": "value",
          "value": "Prescription date : "
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-460"
        }
      },
      "seq": 460,
      "void": false
    },
    {
      "from": null,
      "id": 461,
      "name": "label",
      "parent": 459,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.order_for_date || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-461"
        }
      },
      "seq": 461,
      "void": false
    },
    {
      "from": null,
      "id": 462,
      "name": "div",
      "parent": 379,
      "props": {
        "children": {
          "type": "code",
          "value": "props.tableElement"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-462"
        },
        "style": {
          "type": "code",
          "value": "{ width: props.showToolBox ? \"77%\" : \"100%\"}"
        }
      },
      "seq": 381,
      "void": false
    },
    {
      "from": null,
      "id": 463,
      "name": "label",
      "parent": 383,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผู้สั่ง",
          "valueEN": "Prescribing physician"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-label-463"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"110px\", maxWidth: \"110px\", marginRight: \"12px\"}"
        }
      },
      "seq": 463,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 464,
      "name": "Label",
      "parent": 383,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugOrder?.requested?.name || props.drugOrder?.doctorOrderName || \"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Label-464"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.78rem\", width: \"100%\"}"
        }
      },
      "seq": 464,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 465,
      "name": "FormGroup",
      "parent": 327,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormGroup-465"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 343,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 466,
      "name": "FormField",
      "parent": 465,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-FormField-466"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 466,
      "void": false
    },
    {
      "from": null,
      "id": 467,
      "name": "div",
      "parent": 466,
      "props": {
        "children": {
          "type": "code",
          "value": "props.msgVerbal"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-div-467"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 467,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 468,
      "name": "Button",
      "parent": 329,
      "props": {
        "children": {
          "type": "value",
          "value": "ใบสั่งจ่ายวัตถุออกฤทธิ์",
          "valueEN": "Prescription for psychotropic substances"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderWorkingUX-Button-468"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingStatus?.PRINT_PSYCHOTROPIC_FORM"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPrintPsychotropic"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.buttonActions?.psychotropic?.show ? \"\":\"none\",marginRight: \"0.5rem\"}"
        }
      },
      "seq": 332,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": false,
  "memo": false,
  "name": "CardDrugOrderWorkingUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "backwardActionButton": "REJECT",
    "forwardActionButton": "VERIFY AND PRINT",
    "language": "TH"
  },
  "width": 90
}

*********************************************************************************** */
